import React from "react";
import { FaMapMarkerAlt, FaPhoneAlt, FaChevronRight, FaYoutube } from "react-icons/fa";
import { FiMail } from "react-icons/fi";
import { FaInstagram, FaFacebookF, FaWhatsapp } from "react-icons/fa";

function Footer() {
  return (
    <footer className="bg-[#4a5a22] text-white font-montserrat">
      <div className="max-w-full p-2 mx-auto py-10 px-5 flex flex-col md:flex-row gap-10 md:gap-20">
        
         {/* Box 1: About */}
        
        <div className="flex-1 flex flex-col gap-4">
          <h2 className="text-2xl font-bold mb-4">About Us</h2>
          <p className="text-lg leading-relaxed">
            We are dedicated to helping people achieve their wellness goals
            through natural nutrition guidance, healthy habits, and sustainable
            lifestyle changes. Your health is our priority.
          </p>
        </div>

       

       {/* Box 2: Address & Email */}
         <div className="flex-1 flex flex-col gap-4">
          <h2 className="text-2xl font-bold mb-4">Contact Info</h2>
          <p className="flex items-start gap-3 text-lg">
            <FaMapMarkerAlt className="w-5 h-5 mt-1 min-w-[22px]" />
            Sco 50, below Dominos Pizza, Opp Telephone Exchange, Main Market, Rishi Nagar, Ludhiana
          </p>
          <p className="flex items-center gap-3 text-lg">
            <FiMail className="w-5 h-5 min-w-[22px]" />
            Niharikajain17017@gmail.com
          </p>
        </div>

        {/* Box 3: Phone, Social Icons, Subscribe */}
        <div className="flex-1 flex flex-col gap-6">
          <h2 className="text-2xl font-bold mb-1">Get in Touch</h2>
          <p className="flex items-center gap-2 text-lg">
            <FaPhoneAlt className="w-5 h-5 min-w-[22px]" />
            +91 9023330002
          </p>

          {/* Social Icons */}
          <div className="flex gap-4 text-2xl">
            <FaInstagram className="cursor-pointer" />
            <FaFacebookF className="cursor-pointer" />
            <FaWhatsapp className="cursor-pointer" />
            <FaYoutube className="cursor-pointer" />
          </div>

          {/* Subscribe Section */}
          {/* <div className="border-t border-white/40 pt-5 max-w-sm">
            <h2 className="mb-4 text-xl font-bold">Subscribe</h2>
            <form className="flex items-center w-full max-w-sm" action="#" method="post">
              <input
                type="email"
                placeholder="email@address.com"
                aria-label="Email address"
                required
                className="flex-grow bg-white/30 rounded-l-full px-4 py-3 text-lg text-white placeholder-white/70 outline-none"
              />
              <button
                type="submit"
                aria-label="Subscribe"
                className="bg-white/30 rounded-r-full px-4 py-3 flex items-center justify-center"
              >
                <FaChevronRight className="text-white w-5 h-5" />
              </button>
            </form>
          </div> */}
        </div>
      </div>

      {/* Copyright */}
      <div className="border-t border-white/30 py-5 text-center text-sm md:text-base">
  © {new Date().getFullYear()} Nutritionist. All rights reserved | Develop and Design By{" "}
  <a
    href="https://trikunmarketing.com"
    target="_blank"
    rel="noopener noreferrer"
    className="text-yellow-300 hover:text-yellow-400 underline"
  >
    Trikun Marketing 
  </a>
</div>

    </footer>
  );
}

export default Footer;
